module.exports = __webpack_public_path__ + "static/img/heat-treatment2.e1e3aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatment2.png
// module id = r/eo
// module chunks = 1